@if (activated && panel.isVisible) {
  @for (section of sectionDefinitions; track section) {
    @if (!section.hidden) {
      @switch (section.type) {
        @case ('list') {
          <lm-list
            #LMListComponent
            [listUrlInfo]="section.url"
            [listSpec]="section.spec"
            [fromDataView]="fromDataView"
            inMultiList="true"
            [isInOverlay]="overlayContent"
            (listDisplayed)="onSectionDisplayed($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (contentModified)="onContentModified($event)"
            (listTransactionEvent)="onListTransactionEvent($event)"
            (drillAroundEvent)="onDrillAroundEvent($event)"
          ></lm-list>
        }
        @case ('form') {
          <lm-form
            #LMFormComponent
            [formSpec]="section.spec"
            [formUrlInfo]="section.url"
            [formOptions]="formOptions"
            [fromDataView]="fromDataView"
            [isInOverlay]="overlayContent"
            (formDisplayed)="onSectionDisplayed($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (contentModified)="onContentModified($event)"
          ></lm-form>
        }
      }
    }
  }
}
